import { useState, type FC } from 'react';
import Loader from 'Common/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faSliders, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal } from 'react-bootstrap';
import { HttpStatus } from 'modules/core';
import notistack from 'modules/core/notistack';
import { deleteUser, getUserById, updateUserPermission } from '../services';
import UpdateUserModal from './UpdateUserModal';
import { UserDetailsModel } from '../models';
import RolesPermission from 'modules/user-management/user-master-role/components/RolesPermission';

interface UserMasterActionButtonsModalProps {
    userSelectedId?: number;
    onDeleteSuccess: () => void;
    onUpdateSuccess: () => void;
    reloadDataSource: () => void;
    permissionData: any;
}

const UserMasterActionButtonsModal: FC<UserMasterActionButtonsModalProps> = ({ userSelectedId, onDeleteSuccess, onUpdateSuccess, reloadDataSource, permissionData }) => {
    const [loading, setLoading] = useState(false)
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const [userDetails, setUserDetails] = useState<UserDetailsModel | null>(null);
    const [showUserMasterUpdateModal, setShowUserMasterUpdateModal] = useState(false);
    const [showUserMasterDeleteModal, setShowUserMasterDeleteModal] = useState(false);
    const [selectedRoleId, setSelectedRoleId] = useState({
        roleId: null,
        roleName: "",
    });
    const [showPermissionModal, setShowPermissionModal] = useState(false);


    const handleDeleteUser = (userId: number) => {
        setSelectedUserId(userId);

        setShowUserMasterDeleteModal(true);
    }

    const confirmDeleteUser = async () => {
        if (selectedUserId === null) {
            console.error("No user selected for deletion.");
            return;
        }
        try {
            setLoading(true);
            const response = await deleteUser(selectedUserId);
            if (response.status === HttpStatus.Success) {
                notistack.notifyFromApi(response);
                setShowUserMasterDeleteModal(false);
                onDeleteSuccess();
                reloadDataSource();
            }
            else {
                notistack.notifyFromApi(response);
            }
        }
        catch (error) {
            console.error("Error deleting user:", error);
        }
        finally {
            setLoading(false);
        }
    }

    const handleUpdateUserById = async (userId: number) => {
        try {
            setLoading(true);

            const response = await getUserById(userId);
            if (response.status === HttpStatus.Success) {
                setUserDetails(response.data);
                setShowUserMasterUpdateModal(true);
            } else {
                notistack.notifyFromApi(response);
            }
        }
        catch (error) {
            console.error("Error fetching user details:", error);
        }
        finally {
            setLoading(false);
        }
    }

    const handleOpenPermissionComponent = (data: any) => {
        setSelectedRoleId({
            roleId: data?.id,
            roleName: data?.roleName,
        });
        setShowPermissionModal(true);
    };

    const handleSubmitRolesPermission = async (data: any) => {
        const PermissionData = {
            userId: selectedRoleId?.roleId,
            permissionIds: data,
        };
        try {
            setLoading(true);
            const response = await updateUserPermission(PermissionData);
            if (response.status === HttpStatus.Success) {
                notistack.notifyFromApi(response);
                setShowPermissionModal(false);
                reloadDataSource();
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (error: any) {
            console.error("API Error:", error.message);
            notistack.notifyFromApi(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        setShowUserMasterUpdateModal(false);

    }



    return (<>
        {loading && <Loader />}
        {/* <button className='btn btn-sm action-btn delete-btn' onClick={() => handleDeleteUser(Number(userSelectedId))}>
            <FontAwesomeIcon icon={faTrash} className='ml-2' />
        </button>

        <button
            className='btn btn-sm action-btn edit-btn'
            onClick={() => handleUpdateUserById(Number(userSelectedId))}
        >
            <FontAwesomeIcon icon={faPenToSquare} className='ml-2' />
        </button> */}

        <button
            className="btn btn-sm action-btn permission-btn"
            onClick={() => handleOpenPermissionComponent(permissionData)}
        >
            <FontAwesomeIcon icon={faSliders} className="ml-2" title='Update Permissions' />
        </button>

        {/* Delete Modal */}
        <Modal show={showUserMasterDeleteModal} onHide={() => setShowUserMasterDeleteModal(false)} backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to delete this customer?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowUserMasterDeleteModal(false)}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={confirmDeleteUser} disabled={loading}>
                    {loading ? "Deleting..." : "Delete"}
                </Button>
            </Modal.Footer>
        </Modal>

        {/* Update Modal */}

        <Modal show={showUserMasterUpdateModal}
            onHide={() => setShowUserMasterUpdateModal(false)}
            className="fade" size="xl"
            dialogClassName="modal-dialog-centered"
            backdrop="static"            >
            <Modal.Header closeButton>
                <Modal.Title>Update User Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {userDetails && (
                    <UpdateUserModal onUpdateSucess={onUpdateSuccess} userDetails={userDetails} closeModal={handleCloseModal} />
                )}

            </Modal.Body>
        </Modal>

        {/* permission modal */}
        <RolesPermission
            show={showPermissionModal}
            onClose={() => {
                setShowPermissionModal(false);
                setSelectedRoleId({
                    roleId: null,
                    roleName: "",
                });
            }}
            onSave={(updatedPermissions) => {
                handleSubmitRolesPermission(updatedPermissions);
            }}
            roleId={selectedRoleId?.roleId}
            roleName={selectedRoleId?.roleName}
            flag="User"
        />



    </>);
}

export default UserMasterActionButtonsModal;


